<template>
  <div class="inventory-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>产品库存</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主内容卡片 -->
    <el-card class="main-card" shadow="hover">
      <!-- 搜索和操作区域 -->
      <div class="search-operation-section">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form
              :inline="true"
              :model="searchForm"
              ref="searchForRef"
              label-width="80px"
              autocomplete="on"
              size="small"
              class="search-form"
            >
              <el-form-item>
                <el-input
                  v-model="searchForm.shop_name"
                  placeholder="店铺名称/联系人/手机号"
                  clearable
                  prefix-icon="el-icon-search"
                  style="width: 220px"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="searchForm.product_name"
                  placeholder="产品名称"
                  clearable
                  prefix-icon="el-icon-goods"
                  style="width: 180px"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="searchSubmit"
                >搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="success"
                  icon="el-icon-plus"
                  @click="openDrawer('add')"
                >新增</el-button>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="warning"
                  icon="el-icon-download"
                  @click="exportExcel"
                  :disabled="selectedRows.length === 0"
                >导出({{ selectedRows.length }})</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>

      <!-- 库存统计区域 -->
      <div class="stats-section">
        <!-- 剩余产品库存 -->
        <div class="stats-group">
          <div class="stats-title">
            <i class="el-icon-box"></i>
            <span>剩余产品库存</span>
          </div>
          <el-row :gutter="20" class="stats-row">
            <el-col :span="6" v-for="(item, index) in sumList" :key="index">
              <div class="stat-card">
                <div class="stat-icon">
                  <i class="el-icon-goods"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-value">{{ parseInt(item.total_count) }}</div>
                  <div class="stat-title">{{ item.name }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 已领取产品 -->
        <div class="stats-group">
          <div class="stats-title">
            <i class="el-icon-sold-out"></i>
            <span>已领取产品</span>
          </div>
          <el-row :gutter="20" class="stats-row">
            <el-col :span="6" v-for="(item, index) in sumSellList" :key="index">
              <div class="stat-card">
                <div class="stat-icon">
                  <i class="el-icon-sold-out"></i>
                </div>
                <div class="stat-info">
                  <div class="stat-value">{{ parseInt(item.sell_total_count) }}</div>
                  <div class="stat-title">{{ item.name }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 数据表格区域 -->
      <div class="table-section">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          class="inventory-table"
          :header-cell-style="headerCellStyle"
          @selection-change="handleSelectionChange"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod"></el-table-column>

          <el-table-column label="门店名称" min-width="150" align="center">
            <template slot-scope="scope">
              <span class="cell-text">{{ scope.row.shop ? scope.row.shop.name : '--' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="联系人" width="120" align="center">
            <template slot-scope="scope">
              <span class="cell-text">{{ scope.row.shop ? scope.row.shop.cont_name : '--' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="产品名称" min-width="150" align="center">
            <template slot-scope="scope">
              <span class="cell-text">{{ scope.row.product ? scope.row.product.name : '--' }}</span>
            </template>
          </el-table-column>

          <el-table-column label="单位" width="80" align="center">
            <template slot-scope="scope">
              <el-tag size="small" type="info" effect="plain">
                {{ scope.row.product ? scope.row.product.unit : '--' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="现有数量" width="110" align="center">
            <template slot-scope="scope">
              <span class="count-highlight">{{ scope.row.product_count | removeExtraZeros }}</span>
            </template>
          </el-table-column>

          <el-table-column label="在途数量" width="110" align="center">
            <template slot-scope="scope">
              <span class="count-warning">{{ scope.row.road_count || 0 }}</span>
            </template>
          </el-table-column>

          <el-table-column label="借出数量" width="110" align="center">
            <template slot-scope="scope">
              <span class="count-danger">{{ scope.row.out_count || 0 }}</span>
            </template>
          </el-table-column>

          <el-table-column label="借入数量" width="110" align="center">
            <template slot-scope="scope">
              <span class="count-success">{{ scope.row.in_count || 0 }}</span>
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                class="view-btn"
                @click="goDetail(scope.row)"
              >
                <i class="el-icon-view"></i> 详情
              </el-button>
              <el-button
                type="text"
                size="mini"
                class="edit-btn"
                @click="openDrawer('edit', scope.row)"
              >
                <i class="el-icon-edit-outline"></i> 编辑
              </el-button>
              <el-button
                type="text"
                size="mini"
                class="delete-btn"
                @click="handleDelete(scope.row)"
              >
                <i class="el-icon-delete"></i> 删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-document"></i>
        <p>暂无库存数据</p>
      </div>

      <!-- 分页 -->
      <div class="pagination-section" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 右侧抽屉表单 -->
    <el-drawer
      :title="drawerTitle"
      :visible.sync="drawerVisible"
      direction="rtl"
      size="500px"
      :before-close="handleDrawerClose"
      class="custom-drawer"
    >
      <div class="drawer-content">
        <el-form :model="form" :rules="rules" ref="formRef" label-width="110px" label-position="right">
          <el-form-item label="产品名称" prop="product_id">
            <el-select
              v-model="form.product_id"
              placeholder="请选择产品"
              filterable
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="item in productList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="门店名称" prop="shop_id">
            <el-select
              v-model="form.shop_id"
              placeholder="请选择门店"
              filterable
              clearable
              style="width: 100%"
              @change="handleShopChange"
            >
              <el-option
                v-for="item in shopList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="现有数量" prop="product_count">
            <el-input-number
              v-model="form.product_count"
              :min="0"
              :precision="0"
              controls-position="right"
              style="width: 100%"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="在途数量" prop="road_count">
            <el-input-number
              v-model="form.road_count"
              :min="0"
              :precision="0"
              controls-position="right"
              style="width: 100%"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="借出数量" prop="out_count">
            <el-input-number
              v-model="form.out_count"
              :min="0"
              :precision="0"
              controls-position="right"
              style="width: 100%"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="借入数量" prop="in_count">
            <el-input-number
              v-model="form.in_count"
              :min="0"
              :precision="0"
              controls-position="right"
              style="width: 100%"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="form.remark"
              placeholder="请输入备注信息"
              :rows="3"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button @click="closeDrawer">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
      </div>
    </el-drawer>

    <!-- 详情弹框 -->
    <el-dialog title="库存详情" :visible.sync="detailVisible" width="550px" class="detail-dialog">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="门店名称">{{ detailData.shop_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="产品名称">{{ detailData.product_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="现有数量">
          <span class="count-highlight">{{ detailData.product_count || 0 }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="在途数量">
          <span class="count-warning">{{ detailData.road_count || 0 }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="借出数量">
          <span class="count-danger">{{ detailData.out_count || 0 }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="借入数量">
          <span class="count-success">{{ detailData.in_count || 0 }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="门店联系人">{{ detailData.contact_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="门店电话">{{ detailData.contact_mobile || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ detailData.remark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ detailData.update_time | dateFormat }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import * as XLSX from 'xlsx'

export default {
  name: "productStockList",
  data() {
    return {
      loading: false,
      submitLoading: false,
      
      // 搜索表单
      searchForm: {
        shop_name: "",
        product_name: ""
      },
      
      // 统计数据
      sumList: [],
      sumSellList: [],
      
      // 表格数据
      tableLoadData: [],
      selectedRows: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      
      // 下拉列表数据
      productList: [],
      shopList: [],
      
      // 抽屉表单
      drawerVisible: false,
      drawerTitle: '',
      drawerMode: 'add', // add / edit
      form: {
        id: '',
        product_id: '',
        shop_id: '',
        product_count: 0,
        road_count: 0,
        out_count: 0,
        in_count: 0,
        remark: ''
      },
      
      // 详情弹框
      detailVisible: false,
      detailData: {},
      
      // 验证规则
      rules: {
        product_id: [{ required: true, message: '请选择产品', trigger: 'change' }],
        shop_id: [{ required: true, message: '请选择门店', trigger: 'change' }]
      }
    }
  },
  created() {
    this.DataList()
    this.getWarehouseProductSum()
    this.getProductList()
    this.getShopList()
  },
  filters: {
    dateFormat(time) {
      if (!time) return ""
      return moment(time * 1000).format("YYYY-MM-DD HH:mm:ss")
    },
    removeExtraZeros(num) {
      if (!isNaN(num) && num != null) {
        return num.toString().replace(/\.?0+$/, '')
      }
      return ''
    }
  },
  methods: {
    // 表格样式配置
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    
    // 获取产品列表
    getProductList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token')
      }
      this.$axios.findProductList(param).then(res => {
        if (res.code == 200) {
          this.productList = res.data || []
        }
      })
    },
    
    // 获取门店列表
    getShopList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        proxy_id: sessionStorage.getItem('proxy_id')
      }
      this.$axios.findShopList(param).then(res => {
        if (res.code == 200) {
          this.shopList = res.data || []
        }
      })
    },
    
    // 门店变化时更新联系人信息
    handleShopChange(shopId) {
      const selectedShop = this.shopList.find(item => item.id === shopId)
      if (selectedShop) {
        this.form.contact_name = selectedShop.cont_name
        this.form.contact_mobile = selectedShop.mobile
      }
    },
    
    // 获取统计数据
    getWarehouseProductSum() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token')
      }
      this.$axios.findWarehouseProductSum(param).then(res => {
        if (res.code == 200) {
          this.sumList = this.processProductData(res.data.sumWarehouseProduct)
          this.sumSellList = this.processProductData(res.data.sumSellWarehouseProduct)
        }
      })
    },
    
    processProductData(data) {
      const result = []
      const productMap = { 8: '保温杯', 9: '雨伞', 19: '抽纸' }
      if (data) {
        data.forEach(item => {
          if (productMap[item.product_id]) {
            item.name = productMap[item.product_id]
            result.push(item)
          }
        })
      }
      return result
    },
    
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      if (this.searchForm.shop_name) param.shop_name = this.searchForm.shop_name
      if (this.searchForm.product_name) param.product_name = this.searchForm.product_name
      
      this.$axios.findWarehouseProductListP(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data.data || []
          this.total = res.data.total || 0
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    searchSubmit() {
      this.pageNum = 1
      this.DataList()
    },
    
    // 打开抽屉
    openDrawer(mode, row) {
      this.drawerMode = mode
      this.drawerVisible = true
      this.drawerTitle = mode === 'add' ? '新增库存' : '编辑库存'
      
      if (mode === 'edit' && row) {
        this.form = {
          id: row.id,
          product_id: row.product_id,
          shop_id: row.shop_id,
          product_count: row.product_count || 0,
          road_count: row.road_count || 0,
          out_count: row.out_count || 0,
          in_count: row.in_count || 0,
          remark: row.remark || ''
        }
      } else {
        this.form = {
          id: '',
          product_id: '',
          shop_id: '',
          product_count: 0,
          road_count: 0,
          out_count: 0,
          in_count: 0,
          remark: ''
        }
      }
      this.$nextTick(() => {
        this.$refs.formRef?.clearValidate()
      })
    },
    
    handleDrawerClose(done) {
      if (this.submitLoading) return
      done()
    },
    
    closeDrawer() {
      this.drawerVisible = false
    },
    
    // 提交表单
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const param = {
            ...this.form,
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token')
          }
          
          const apiMethod = this.drawerMode === 'add' 
            ? this.$axios.addWarehouseProduct 
            : this.$axios.updateWarehouseProduct
            
          apiMethod(param).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.closeDrawer()
              this.DataList()
              this.getWarehouseProductSum()
            } else {
              this.$message.error(res.msg)
            }
          }).catch(error => {
            console.log(error)
            this.$message.error('操作失败')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    },
    
    // 查看详情
    goDetail(row) {
      this.detailData = {
        shop_name: row.shop?.name,
        product_name: row.product?.name,
        product_count: row.product_count,
        road_count: row.road_count,
        out_count: row.out_count,
        in_count: row.in_count,
        contact_name: row.shop?.cont_name,
        contact_mobile: row.shop?.mobile,
        remark: row.remark,
        update_time: row.update_time
      }
      this.detailVisible = true
    },
    
    // 删除
    handleDelete(row) {
      this.$confirm(`确定要删除该库存记录吗？删除后无法恢复`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        const param = {
          id: row.id,
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token')
        }
        this.$axios.delWarehouseProduct(param).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.DataList()
            this.getWarehouseProductSum()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    
    // 导出Excel
    exportExcel() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要导出的数据')
        return
      }
      
      const exportData = this.selectedRows.map((row, index) => ({
        '序号': index + 1,
        '门店名称': row.shop?.name || '--',
        '联系人': row.shop?.cont_name || '--',
        '联系电话': row.shop?.mobile || '--',
        '产品名称': row.product?.name || '--',
        '单位': row.product?.unit || '--',
        '现有数量': row.product_count || 0,
        '在途数量': row.road_count || 0,
        '借出数量': row.out_count || 0,
        '借入数量': row.in_count || 0,
        '备注': row.remark || '--',
        '更新时间': row.update_time ? moment(row.update_time * 1000).format('YYYY-MM-DD HH:mm:ss') : '--'
      }))
      
      const worksheet = XLSX.utils.json_to_sheet(exportData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '产品库存列表')
      
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `产品库存_${moment().format('YYYYMMDDHHmmss')}.xlsx`
      link.click()
      URL.revokeObjectURL(link.href)
      
      this.$message.success(`成功导出 ${this.selectedRows.length} 条数据`)
    }
  }
}
</script>

<style lang="scss" scoped>
.inventory-container {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-container {
  margin-bottom: 20px;
}

.main-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  
  ::v-deep .el-card__body {
    padding: 20px 24px;
  }
}

// 搜索区域
.search-operation-section {
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
  
  .search-form {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
  }
}

// 统计卡片
.stats-group {
  margin-bottom: 24px;
  
  .stats-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    padding-left: 8px;
    border-left: 3px solid #1677ff;
    
    i {
      font-size: 16px;
      color: #1677ff;
    }
    
    span {
      font-size: 15px;
      font-weight: 600;
      color: #1f2d3d;
    }
  }
}

.stat-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  }
  
  .stat-icon {
    width: 56px;
    height: 56px;
    background: linear-gradient(135deg, #1677ff, #69a5ff);
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    i {
      font-size: 28px;
      color: #fff;
    }
  }
  
  .stat-info {
    .stat-value {
      font-size: 28px;
      font-weight: 700;
      color: #1f2d3d;
      line-height: 1.2;
    }
    
    .stat-title {
      font-size: 13px;
      color: #8c8f98;
      margin-top: 4px;
    }
  }
}

// 表格样式
.table-section {
  margin-bottom: 20px;
}

.inventory-table {
  border-radius: 12px;
  overflow: hidden;
  
  ::v-deep .el-table__header th {
    background: #fafbfc !important;
  }
  
  .cell-text {
    font-size: 13px;
    color: #606266;
  }
  
  .count-highlight {
    color: #1677ff;
    font-weight: 600;
  }
  
  .count-warning {
    color: #e6a23c;
    font-weight: 600;
  }
  
  .count-danger {
    color: #ff4d4f;
    font-weight: 600;
  }
  
  .count-success {
    color: #00b578;
    font-weight: 600;
  }
}

.view-btn, .edit-btn, .delete-btn {
  margin: 0 4px;
  
  i {
    margin-right: 4px;
  }
}

.view-btn { color: #909399; &:hover { color: #a6a9ad; } }
.edit-btn { color: #1677ff; &:hover { color: #4096ff; } }
.delete-btn { color: #ff4d4f; &:hover { color: #ff7875; } }

// 空状态
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #c0c4cc;
  
  i {
    font-size: 64px;
  }
  
  p {
    margin-top: 16px;
    font-size: 14px;
  }
}

// 分页
.pagination-section {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

// 抽屉样式
.custom-drawer {
  ::v-deep .el-drawer__header {
    background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%);
    margin-bottom: 0;
    padding: 20px 24px;
    
    span {
      color: #fff;
      font-size: 18px;
      font-weight: 500;
    }
    
    .el-drawer__close-btn {
      color: #fff;
      
      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
  
  ::v-deep .el-drawer__body {
    padding: 0;
  }
}

.drawer-content {
  padding: 24px;
}

.drawer-footer {
  padding: 16px 24px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

// 详情弹框
.detail-dialog {
  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%);
    
    .el-dialog__title {
      color: #fff;
    }
    
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }
  }
}
</style>